// ----------------------
// <auto-generated>
// Generated using the script normalizrGetterGenerator.js
// </auto-generated>
// -----------------------
import { denormalize, schema } from 'normalizr';
import {
    Address,
    AssetFamily,
    AssetNature,
    BillingAddressDetails,
    BillingBankDetailDetails,
    BillingOrderNumberDetails,
    ChangeFinancialConditionDetails,
    ChangeHeadOfficeAddressDetails,
    Contract,
    ContractAssets,
    ContractBilling,
    ContractInformation,
    ContractTransferDetails,
    CustomerRequestsSummary,
    DocumentAccountExtractDetails,
    DocumentContractRelatedDetails,
    DocumentCopyOfContractualElementDetails,
    DocumentEquipmentRelatedDetails,
    EndOfContractDenialOfContractRenewalDetails,
    EndOfContractEarlyRedemptionDetails,
    EndOfContractExerciseOfPurchaseOptionDetails,
    EndOfContractReturnOfEquipmentDetails,
    EndOfContractTerminationOfContractDetails,
    Equipment,
    FinancialRequestDetailed,
    FinancialRequestSummary,
    Funding,
    Invoice,
    LoggedUser,
    Person,
    SaveFinancialResponse,
    Status,
    ThirdAddress,
    UserInfo,
} from 'services/ApiService/Franfinance/FranfinanceApiClient';
import { FranfinanceApiSchema, IFranfinanceEntities } from 'services/ApiService';

export class FranfinanceSelectors {
    public static getAddress(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<Address>(
             id, 
             entities,
             FranfinanceApiSchema.AddressSchema.key,
             FranfinanceApiSchema.AddressSchema);
    }

    public static getAssetFamily(id: number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<AssetFamily>(
             id, 
             entities,
             FranfinanceApiSchema.AssetFamilySchema.key,
             FranfinanceApiSchema.AssetFamilySchema);
    }

    public static getAssetNature(id: number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<AssetNature>(
             id, 
             entities,
             FranfinanceApiSchema.AssetNatureSchema.key,
             FranfinanceApiSchema.AssetNatureSchema);
    }

    public static getBillingAddressDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<BillingAddressDetails>(
             id, 
             entities,
             FranfinanceApiSchema.BillingAddressDetailsSchema.key,
             FranfinanceApiSchema.BillingAddressDetailsSchema);
    }

    public static getBillingBankDetailDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<BillingBankDetailDetails>(
             id, 
             entities,
             FranfinanceApiSchema.BillingBankDetailDetailsSchema.key,
             FranfinanceApiSchema.BillingBankDetailDetailsSchema);
    }

    public static getBillingOrderNumberDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<BillingOrderNumberDetails>(
             id, 
             entities,
             FranfinanceApiSchema.BillingOrderNumberDetailsSchema.key,
             FranfinanceApiSchema.BillingOrderNumberDetailsSchema);
    }

    public static getChangeFinancialConditionDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<ChangeFinancialConditionDetails>(
             id, 
             entities,
             FranfinanceApiSchema.ChangeFinancialConditionDetailsSchema.key,
             FranfinanceApiSchema.ChangeFinancialConditionDetailsSchema);
    }

    public static getChangeHeadOfficeAddressDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<ChangeHeadOfficeAddressDetails>(
             id, 
             entities,
             FranfinanceApiSchema.ChangeHeadOfficeAddressDetailsSchema.key,
             FranfinanceApiSchema.ChangeHeadOfficeAddressDetailsSchema);
    }

    public static getContract(id: string | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<Contract>(
             id, 
             entities,
             FranfinanceApiSchema.ContractSchema.key,
             FranfinanceApiSchema.ContractSchema);
    }

    public static getContractAssets(id: string | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<ContractAssets>(
             id, 
             entities,
             FranfinanceApiSchema.ContractAssetsSchema.key,
             FranfinanceApiSchema.ContractAssetsSchema);
    }

    public static getContractBilling(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<ContractBilling>(
             id, 
             entities,
             FranfinanceApiSchema.ContractBillingSchema.key,
             FranfinanceApiSchema.ContractBillingSchema);
    }

    public static getContractInformation(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<ContractInformation>(
             id, 
             entities,
             FranfinanceApiSchema.ContractInformationSchema.key,
             FranfinanceApiSchema.ContractInformationSchema);
    }

    public static getContractTransferDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<ContractTransferDetails>(
             id, 
             entities,
             FranfinanceApiSchema.ContractTransferDetailsSchema.key,
             FranfinanceApiSchema.ContractTransferDetailsSchema);
    }

    public static getCustomerRequestsSummary(id: string | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<CustomerRequestsSummary>(
             id, 
             entities,
             FranfinanceApiSchema.CustomerRequestsSummarySchema.key,
             FranfinanceApiSchema.CustomerRequestsSummarySchema);
    }

    public static getDocumentAccountExtractDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<DocumentAccountExtractDetails>(
             id, 
             entities,
             FranfinanceApiSchema.DocumentAccountExtractDetailsSchema.key,
             FranfinanceApiSchema.DocumentAccountExtractDetailsSchema);
    }

    public static getDocumentContractRelatedDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<DocumentContractRelatedDetails>(
             id, 
             entities,
             FranfinanceApiSchema.DocumentContractRelatedDetailsSchema.key,
             FranfinanceApiSchema.DocumentContractRelatedDetailsSchema);
    }

    public static getDocumentCopyOfContractualElementDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<DocumentCopyOfContractualElementDetails>(
             id, 
             entities,
             FranfinanceApiSchema.DocumentCopyOfContractualElementDetailsSchema.key,
             FranfinanceApiSchema.DocumentCopyOfContractualElementDetailsSchema);
    }

    public static getDocumentEquipmentRelatedDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<DocumentEquipmentRelatedDetails>(
             id, 
             entities,
             FranfinanceApiSchema.DocumentEquipmentRelatedDetailsSchema.key,
             FranfinanceApiSchema.DocumentEquipmentRelatedDetailsSchema);
    }

    public static getEndOfContractDenialOfContractRenewalDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<EndOfContractDenialOfContractRenewalDetails>(
             id, 
             entities,
             FranfinanceApiSchema.EndOfContractDenialOfContractRenewalDetailsSchema.key,
             FranfinanceApiSchema.EndOfContractDenialOfContractRenewalDetailsSchema);
    }

    public static getEndOfContractEarlyRedemptionDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<EndOfContractEarlyRedemptionDetails>(
             id, 
             entities,
             FranfinanceApiSchema.EndOfContractEarlyRedemptionDetailsSchema.key,
             FranfinanceApiSchema.EndOfContractEarlyRedemptionDetailsSchema);
    }

    public static getEndOfContractExerciseOfPurchaseOptionDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<EndOfContractExerciseOfPurchaseOptionDetails>(
             id, 
             entities,
             FranfinanceApiSchema.EndOfContractExerciseOfPurchaseOptionDetailsSchema.key,
             FranfinanceApiSchema.EndOfContractExerciseOfPurchaseOptionDetailsSchema);
    }

    public static getEndOfContractReturnOfEquipmentDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<EndOfContractReturnOfEquipmentDetails>(
             id, 
             entities,
             FranfinanceApiSchema.EndOfContractReturnOfEquipmentDetailsSchema.key,
             FranfinanceApiSchema.EndOfContractReturnOfEquipmentDetailsSchema);
    }

    public static getEndOfContractTerminationOfContractDetails(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<EndOfContractTerminationOfContractDetails>(
             id, 
             entities,
             FranfinanceApiSchema.EndOfContractTerminationOfContractDetailsSchema.key,
             FranfinanceApiSchema.EndOfContractTerminationOfContractDetailsSchema);
    }

    public static getEquipment(id: number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<Equipment>(
             id, 
             entities,
             FranfinanceApiSchema.EquipmentSchema.key,
             FranfinanceApiSchema.EquipmentSchema);
    }

    public static getFinancialRequestDetailed(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<FinancialRequestDetailed>(
             id, 
             entities,
             FranfinanceApiSchema.FinancialRequestDetailedSchema.key,
             FranfinanceApiSchema.FinancialRequestDetailedSchema);
    }

    public static getFinancialRequestSummary(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<FinancialRequestSummary>(
             id, 
             entities,
             FranfinanceApiSchema.FinancialRequestSummarySchema.key,
             FranfinanceApiSchema.FinancialRequestSummarySchema);
    }

    public static getFunding(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<Funding>(
             id, 
             entities,
             FranfinanceApiSchema.FundingSchema.key,
             FranfinanceApiSchema.FundingSchema);
    }

    public static getInvoice(id: string | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<Invoice>(
             id, 
             entities,
             FranfinanceApiSchema.InvoiceSchema.key,
             FranfinanceApiSchema.InvoiceSchema);
    }

    public static getLoggedUser(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<LoggedUser>(
             id, 
             entities,
             FranfinanceApiSchema.LoggedUserSchema.key,
             FranfinanceApiSchema.LoggedUserSchema);
    }

    public static getPerson(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<Person>(
             id, 
             entities,
             FranfinanceApiSchema.PersonSchema.key,
             FranfinanceApiSchema.PersonSchema);
    }

    public static getSaveFinancialResponse(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<SaveFinancialResponse>(
             id, 
             entities,
             FranfinanceApiSchema.SaveFinancialResponseSchema.key,
             FranfinanceApiSchema.SaveFinancialResponseSchema);
    }

    public static getStatus(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<Status>(
             id, 
             entities,
             FranfinanceApiSchema.StatusSchema.key,
             FranfinanceApiSchema.StatusSchema);
    }

    public static getThirdAddress(id: string | number | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<ThirdAddress>(
             id, 
             entities,
             FranfinanceApiSchema.ThirdAddressSchema.key,
             FranfinanceApiSchema.ThirdAddressSchema);
    }

    public static getUserInfo(id: string | null | undefined, entities: IFranfinanceEntities) {
        return FranfinanceSelectors.get<UserInfo>(
             id, 
             entities,
             FranfinanceApiSchema.UserInfoSchema.key,
             FranfinanceApiSchema.UserInfoSchema);
    }

    public static getAddressArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<Address>(
                ids,
                entities,
                FranfinanceApiSchema.AddressSchema.key,
                FranfinanceApiSchema.AddressSchemaArray);
    }

    public static getAssetFamilyArray(
        ids: ReadonlyArray<number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<AssetFamily>(
                ids,
                entities,
                FranfinanceApiSchema.AssetFamilySchema.key,
                FranfinanceApiSchema.AssetFamilySchemaArray);
    }

    public static getAssetNatureArray(
        ids: ReadonlyArray<number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<AssetNature>(
                ids,
                entities,
                FranfinanceApiSchema.AssetNatureSchema.key,
                FranfinanceApiSchema.AssetNatureSchemaArray);
    }

    public static getBillingAddressDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<BillingAddressDetails>(
                ids,
                entities,
                FranfinanceApiSchema.BillingAddressDetailsSchema.key,
                FranfinanceApiSchema.BillingAddressDetailsSchemaArray);
    }

    public static getBillingBankDetailDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<BillingBankDetailDetails>(
                ids,
                entities,
                FranfinanceApiSchema.BillingBankDetailDetailsSchema.key,
                FranfinanceApiSchema.BillingBankDetailDetailsSchemaArray);
    }

    public static getBillingOrderNumberDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<BillingOrderNumberDetails>(
                ids,
                entities,
                FranfinanceApiSchema.BillingOrderNumberDetailsSchema.key,
                FranfinanceApiSchema.BillingOrderNumberDetailsSchemaArray);
    }

    public static getChangeFinancialConditionDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<ChangeFinancialConditionDetails>(
                ids,
                entities,
                FranfinanceApiSchema.ChangeFinancialConditionDetailsSchema.key,
                FranfinanceApiSchema.ChangeFinancialConditionDetailsSchemaArray);
    }

    public static getChangeHeadOfficeAddressDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<ChangeHeadOfficeAddressDetails>(
                ids,
                entities,
                FranfinanceApiSchema.ChangeHeadOfficeAddressDetailsSchema.key,
                FranfinanceApiSchema.ChangeHeadOfficeAddressDetailsSchemaArray);
    }

    public static getContractArray(
        ids: ReadonlyArray<string> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<Contract>(
                ids,
                entities,
                FranfinanceApiSchema.ContractSchema.key,
                FranfinanceApiSchema.ContractSchemaArray);
    }

    public static getContractAssetsArray(
        ids: ReadonlyArray<string> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<ContractAssets>(
                ids,
                entities,
                FranfinanceApiSchema.ContractAssetsSchema.key,
                FranfinanceApiSchema.ContractAssetsSchemaArray);
    }

    public static getContractBillingArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<ContractBilling>(
                ids,
                entities,
                FranfinanceApiSchema.ContractBillingSchema.key,
                FranfinanceApiSchema.ContractBillingSchemaArray);
    }

    public static getContractInformationArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<ContractInformation>(
                ids,
                entities,
                FranfinanceApiSchema.ContractInformationSchema.key,
                FranfinanceApiSchema.ContractInformationSchemaArray);
    }

    public static getContractTransferDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<ContractTransferDetails>(
                ids,
                entities,
                FranfinanceApiSchema.ContractTransferDetailsSchema.key,
                FranfinanceApiSchema.ContractTransferDetailsSchemaArray);
    }

    public static getCustomerRequestsSummaryArray(
        ids: ReadonlyArray<string> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<CustomerRequestsSummary>(
                ids,
                entities,
                FranfinanceApiSchema.CustomerRequestsSummarySchema.key,
                FranfinanceApiSchema.CustomerRequestsSummarySchemaArray);
    }

    public static getDocumentAccountExtractDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<DocumentAccountExtractDetails>(
                ids,
                entities,
                FranfinanceApiSchema.DocumentAccountExtractDetailsSchema.key,
                FranfinanceApiSchema.DocumentAccountExtractDetailsSchemaArray);
    }

    public static getDocumentContractRelatedDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<DocumentContractRelatedDetails>(
                ids,
                entities,
                FranfinanceApiSchema.DocumentContractRelatedDetailsSchema.key,
                FranfinanceApiSchema.DocumentContractRelatedDetailsSchemaArray);
    }

    public static getDocumentCopyOfContractualElementDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<DocumentCopyOfContractualElementDetails>(
                ids,
                entities,
                FranfinanceApiSchema.DocumentCopyOfContractualElementDetailsSchema.key,
                FranfinanceApiSchema.DocumentCopyOfContractualElementDetailsSchemaArray);
    }

    public static getDocumentEquipmentRelatedDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<DocumentEquipmentRelatedDetails>(
                ids,
                entities,
                FranfinanceApiSchema.DocumentEquipmentRelatedDetailsSchema.key,
                FranfinanceApiSchema.DocumentEquipmentRelatedDetailsSchemaArray);
    }

    public static getEndOfContractDenialOfContractRenewalDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<EndOfContractDenialOfContractRenewalDetails>(
                ids,
                entities,
                FranfinanceApiSchema.EndOfContractDenialOfContractRenewalDetailsSchema.key,
                FranfinanceApiSchema.EndOfContractDenialOfContractRenewalDetailsSchemaArray);
    }

    public static getEndOfContractEarlyRedemptionDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<EndOfContractEarlyRedemptionDetails>(
                ids,
                entities,
                FranfinanceApiSchema.EndOfContractEarlyRedemptionDetailsSchema.key,
                FranfinanceApiSchema.EndOfContractEarlyRedemptionDetailsSchemaArray);
    }

    public static getEndOfContractExerciseOfPurchaseOptionDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<EndOfContractExerciseOfPurchaseOptionDetails>(
                ids,
                entities,
                FranfinanceApiSchema.EndOfContractExerciseOfPurchaseOptionDetailsSchema.key,
                FranfinanceApiSchema.EndOfContractExerciseOfPurchaseOptionDetailsSchemaArray);
    }

    public static getEndOfContractReturnOfEquipmentDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<EndOfContractReturnOfEquipmentDetails>(
                ids,
                entities,
                FranfinanceApiSchema.EndOfContractReturnOfEquipmentDetailsSchema.key,
                FranfinanceApiSchema.EndOfContractReturnOfEquipmentDetailsSchemaArray);
    }

    public static getEndOfContractTerminationOfContractDetailsArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<EndOfContractTerminationOfContractDetails>(
                ids,
                entities,
                FranfinanceApiSchema.EndOfContractTerminationOfContractDetailsSchema.key,
                FranfinanceApiSchema.EndOfContractTerminationOfContractDetailsSchemaArray);
    }

    public static getEquipmentArray(
        ids: ReadonlyArray<number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<Equipment>(
                ids,
                entities,
                FranfinanceApiSchema.EquipmentSchema.key,
                FranfinanceApiSchema.EquipmentSchemaArray);
    }

    public static getFinancialRequestDetailedArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<FinancialRequestDetailed>(
                ids,
                entities,
                FranfinanceApiSchema.FinancialRequestDetailedSchema.key,
                FranfinanceApiSchema.FinancialRequestDetailedSchemaArray);
    }

    public static getFinancialRequestSummaryArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<FinancialRequestSummary>(
                ids,
                entities,
                FranfinanceApiSchema.FinancialRequestSummarySchema.key,
                FranfinanceApiSchema.FinancialRequestSummarySchemaArray);
    }

    public static getFundingArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<Funding>(
                ids,
                entities,
                FranfinanceApiSchema.FundingSchema.key,
                FranfinanceApiSchema.FundingSchemaArray);
    }

    public static getInvoiceArray(
        ids: ReadonlyArray<string> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<Invoice>(
                ids,
                entities,
                FranfinanceApiSchema.InvoiceSchema.key,
                FranfinanceApiSchema.InvoiceSchemaArray);
    }

    public static getLoggedUserArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<LoggedUser>(
                ids,
                entities,
                FranfinanceApiSchema.LoggedUserSchema.key,
                FranfinanceApiSchema.LoggedUserSchemaArray);
    }

    public static getPersonArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<Person>(
                ids,
                entities,
                FranfinanceApiSchema.PersonSchema.key,
                FranfinanceApiSchema.PersonSchemaArray);
    }

    public static getSaveFinancialResponseArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<SaveFinancialResponse>(
                ids,
                entities,
                FranfinanceApiSchema.SaveFinancialResponseSchema.key,
                FranfinanceApiSchema.SaveFinancialResponseSchemaArray);
    }

    public static getStatusArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<Status>(
                ids,
                entities,
                FranfinanceApiSchema.StatusSchema.key,
                FranfinanceApiSchema.StatusSchemaArray);
    }

    public static getThirdAddressArray(
        ids: ReadonlyArray<string | number> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<ThirdAddress>(
                ids,
                entities,
                FranfinanceApiSchema.ThirdAddressSchema.key,
                FranfinanceApiSchema.ThirdAddressSchemaArray);
    }

    public static getUserInfoArray(
        ids: ReadonlyArray<string> | null | undefined, 
        entities: IFranfinanceEntities) {
            return FranfinanceSelectors
            .getArray<UserInfo>(
                ids,
                entities,
                FranfinanceApiSchema.UserInfoSchema.key,
                FranfinanceApiSchema.UserInfoSchemaArray);
    }

    private static get<T>(id: string | number | null | undefined, entities: IFranfinanceEntities, schemaKey: string, schema: schema.Entity<T>) {
        if (!FranfinanceSelectors.hasEntitySchema(entities, schemaKey)) {
            return undefined;
        }
        return (denormalize(id, schema, entities) || undefined) as T | undefined;
    }

    private static getArray<T>(ids: ReadonlyArray<string | number> | null | undefined, entities: IFranfinanceEntities, schemaKey: string, schema: schema.Array<T>) {
        if (!ids?.length || !FranfinanceSelectors.hasEntitySchema(entities, schemaKey)) {
            return [];
        }
        return denormalize(ids, schema, entities) as T[];
    }

    private static hasEntitySchema(entities: IFranfinanceEntities, schemaKey: string) {
        return entities.hasOwnProperty(schemaKey);
    }
}
